// extracted by mini-css-extract-plugin
export default {"root":"FilterFacesModal__root--10hJb","title":"FilterFacesModal__title--AIjMn"};